import { MutableRefObject, useEffect, useRef, useState } from "react";
import { Note } from "../../../Data/HexMap/Note";
import { Music } from "../../../Util/Music/Music";
import { ChapterConfig } from "../../ChapterConfig";
import { HexBuilder } from "../../Exercises/HexBuilder/HexBuilder";
import { OutlineBox } from "../../../Comps/OutlineBox/OutlineBox";
import { ChapterNav, ChapterNavItem } from "../ChapterNav/ChapterNav";
import { ChapterRoutes } from "../ChapterNav/ChapterRoutes";
import { HxMapGroup } from "../../../Comps/HxMap/HxMapGroup";
import { All } from "../../../Util/Constants/Quantities";
import { HexMap } from "../../../Data/HexMap/HexMap";
import { HexMapBuilderParams, BuildHexMap } from "../../../Data/HexMap/HexMapBuilder";
import { HexMapModifier } from "../../../Data/HexMap/HexMapModifier";
import { TransformTranslate } from "../../../Util/Transform/Transform";
import { HexPattern } from "../../../Comps/HexPattern/HexPattern";
import { NoteCircle } from "../../../Comps/NoteCircle/NoteCircle";
import { ClearHelpers } from "../../Helpers/ClearHelpers/ClearHelpers";
import { Helpers } from "../../Helpers/Helpers";
import { HexKeyMemorizer } from "../../Exercises/HexKeyMemorizer/HexKeyMemorizer";
import './BuildingTheHexKey.scss'
import { useNoteName } from "../../../Project/ProjectStore";
import { useNotePlayer } from "../../../Sound/SoundStore";
import { NotePlayer } from "../../../Sound/NotePlayer";

export function BuildingTheHexKey(props:ChapterConfig){
    const subPaths:ChapterNavItem[] = [
        {title:'Lesson', path:'lesson', element:<ClearHelpers key={0}><Lesson/></ClearHelpers>},
        {title:'HexKey Builder Exercise', isExercise:true, path:'hexbuilder', element:<ClearHelpers key={1} openHelpers={[Helpers.HexPattern, Helpers.MusicalAlphabet]}><BuilderExercise/></ClearHelpers>},
        {title:'HexKey Memorizer', isExercise:true, path:'hexkey_memorizer', element:<ClearHelpers key={2}><HexKeyMemorizer/></ClearHelpers>}
    ]
    return  <div>
                <h1>Building the Hex Key</h1>
                <ChapterNav path={props.path} subPaths={subPaths}/>
                <ChapterRoutes chapterNavs={subPaths}/>
            </div>
}
export function BuilderExercise(){
    return(<HexBuilder/>)
}

export function Lesson(){
    const tonic:number = Music.E
    const notePlayer:MutableRefObject<NotePlayer> = useRef(useNotePlayer())
    useEffect(()=>{notePlayer.current.setTonic(tonic)},[])
    const [hilitedNotes, setHilitedNotes] = useState<number[]>([])
    const getHilitedNoteTonics = () => {
        const hilitedTonics:number[] = []
        const keyScale:number[] = Music.getKeyScale(tonic)
        hilitedNotes.forEach((noteIndex:number)=>{
            const noteTonic:number = keyScale[noteIndex]
            hilitedTonics.push(noteTonic)
        })
        return hilitedTonics
    }
    const onNoteClick = (note:Note) => {
        notePlayer.current.playNote(note.params.tonic)
        setHilitedNotes(hilitedNotes.concat([note.params.noteIndex]))
    }
    const getHexMap = () => {
        const initializeMap = (modifier:HexMapModifier) => {
            modifier.notes_setDefined([All], false)
            modifier.notes_setDefined(hilitedNotes, true)
            modifier.notes_setSelected(hilitedNotes)
        }
        const params:HexMapBuilderParams = {
            rows:1, columns:1, tonic:tonic, radius:100
        }
        const map:HexMap = BuildHexMap(params)
        const mod:HexMapModifier = new HexMapModifier(map)
        initializeMap(mod)
        return map
    }
    const svgWidth:number = 280
    const svgHeight:number = 280
    const hexRadius:number = 100
    const tonicName:string = useNoteName(tonic)
    return(
        <OutlineBox title={`Building the Key of ${tonicName} as a HexKey`} width={800}>
            <div className={'BuildingTheHexKey Lesson'}>
                <div style={{display:'flex', margin:'auto'}}>
                        <div style={{flex:1}}>
                            <svg width={svgWidth} height={svgHeight}>
                                <g transform={TransformTranslate(svgWidth/2,svgHeight/2)}>
                                    <HxMapGroup hexMap={getHexMap()} onNoteClick={onNoteClick}></HxMapGroup>
                                </g>
                            </svg>
                        </div>
                        <div style={{flex:1}}>
                            <HexPattern onNoteClick = {onNoteClick} hilitedNotes={hilitedNotes} height={svgHeight} width={svgWidth} radius={100}/>
                        </div>
                </div>
                <div style={{display:'flex', margin:'auto'}}>
                        <div style={{flex:1}}>
                            <NoteCircle radius={hexRadius} height={svgHeight} width={svgWidth} hilitedNotes={getHilitedNoteTonics()}/>
                        </div>
                </div>
            </div>
        </OutlineBox>
    )
}

